import { render, staticRenderFns } from "./StatisticsRechargeWithdraw.vue?vue&type=template&id=270aa24b&scoped=true&"
import script from "./StatisticsRechargeWithdraw.vue?vue&type=script&lang=js&"
export * from "./StatisticsRechargeWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsRechargeWithdraw.vue?vue&type=style&index=0&id=270aa24b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270aa24b",
  null
  
)

export default component.exports